import { jsx as _jsx } from "react/jsx-runtime";
import { Grid, Typography } from '@mui/material';
import AppBar from '@mui/material/AppBar';
const DocumentBar = ({ name, }) => (_jsx(AppBar, { position: "static", elevation: 0, className: "courseInfoBar", sx: {
        width: '100%',
        minHeight: 61,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        overflow: 'hidden',
    }, children: _jsx(Grid, { container: true, sx: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            px: 2.5,
        }, children: _jsx(Grid, { item: true, xs: 12, md: 6, sx: {
                display: 'flex',
                flexDirection: 'row',
                overflow: 'hidden',
            }, children: _jsx(Typography, { variant: "subtitle1", className: "courseInfoBarTitle", sx: { paddingLeft: 2 }, children: name }) }) }) }));
export default DocumentBar;
//# sourceMappingURL=DocumentBar.js.map